module.exports = __webpack_public_path__ + "static/media/monster.f70c57c6.PNG";